<div class="layout-oldelval" *ngIf="true">
    <!-- TOPBAR (mismo que pantallas internas) -->
    <app-topbar></app-topbar>

    <!-- HERO / INTRO -->
    <header class="hero-modern">
        <div class="hero-inner">
            <div class="intro">
                <h1>
                    Bienvenido<span *ngIf="displayName">, {{ displayName }}</span>
                </h1>
                <p class="tagline">
                    Accede a los módulos corporativos de la plataforma.<br />
                    Selecciona un sistema para comenzar tu jornada.
                </p>
            </div>
        </div>
    </header>

    <!-- MAIN GRID -->
    <main class="systems-wrapper">
        <!-- Cartel de sistema en mantenimiento para usuarios no-admin -->
        <div *ngIf="isMaintenanceUser" class="maintenance-banner">
            <div class="mb-icon"><span class="pi pi-wrench"></span></div>
            <h2>Sistema en mantenimiento</h2>
            <p>Estamos realizando tareas de mantenimiento para mejorar el servicio.<br />El sistema estará disponible nuevamente en breve.</p>
            <p class="mb-contact"><span class="pi pi-info-circle"></span> Para asistencia, contactá al administrador del sistema.</p>
        </div>

        <!-- Skeleton -->
        <div *ngIf="!isMaintenanceUser && loading" class="skeleton-grid">
            <div class="sk-card" *ngFor="let i of skeletons"></div>
        </div>

        <div *ngIf="!isMaintenanceUser && !loading && !isEmpty" class="systems-grid" [class.centered]="filteredSystems().length < 4">
            @for (sistema of filteredSystems(); track sistema.id) {
                <article class="system-card" (click)="navigate(sistema.id, sistema.locked)" [class.disabled]="sistema.locked" [attr.aria-disabled]="sistema.locked" tabindex="0">
                    <div class="media">
                        <img [src]="'assets/images/' + sistema.img" [alt]="sistema.nombre" />
                        <div class="overlay"></div>
                        <div class="lock-badge" *ngIf="sistema.locked" pTooltip="Sin permiso de acceso" tooltipPosition="left">
                            <span class="pi pi-lock"></span>
                        </div>
                    </div>
                    <div class="body">
                        <div class="card-row">
                            <h3 class="title">{{ sistema.nombre }}</h3>
                            <span *ngIf="!sistema.locked" class="enter"> Ingresar <span class="pi pi-arrow-right"></span> </span>
                        </div>
                        <p class="description" *ngIf="getSystemDescription(sistema.nombre)">
                            {{ getSystemDescription(sistema.nombre) }}
                        </p>
                    </div>
                </article>
            }
        </div>

        <!-- Empty state -->
        <div *ngIf="!isMaintenanceUser && isEmpty" class="empty-state">
            <div class="icon"><span class="pi pi-folder-open"></span></div>
            <h3>Sin sistemas asignados</h3>
            <p>Contacta al administrador si crees que se trata de un error.</p>
            <button pButton type="button" label="Reintentar" icon="pi pi-refresh" (click)="reloadSystems()"></button>
        </div>
    </main>

    <!-- OVERLAY DE PRE-AVISO DE MANTENIMIENTO (aparece cada 5 min, auto-cierre en 10s) -->
    <div class="mnt-overlay" *ngIf="showMaintenanceOverlay" (click)="dismissMaintenanceOverlay()">
        <div class="mnt-dialog" (click)="$event.stopPropagation()">
            <div class="mnt-glow"></div>
            <div class="mnt-icon-wrap">
                <span class="pi pi-clock mnt-icon"></span>
            </div>
            <div class="mnt-badge">AVISO DE MANTENIMIENTO</div>
            <h2 class="mnt-title">Próximo mantenimiento programado</h2>
            <p class="mnt-desc">{{ preNoticeMessage }}</p>
            <p class="mnt-contact">
                <span class="pi pi-info-circle"></span>
                Te recomendamos guardar tu trabajo antes de que comience.
            </p>
            <div class="mnt-footer">
                <div class="mnt-countdown">
                    <svg viewBox="0 0 36 36" class="mnt-ring">
                        <circle class="mnt-ring-bg" cx="18" cy="18" r="15" />
                        <circle class="mnt-ring-fg" cx="18" cy="18" r="15" [style.stroke-dashoffset]="94.2 - (94.2 * maintenanceCountdown) / 10" />
                    </svg>
                    <span class="mnt-secs">{{ maintenanceCountdown }}</span>
                </div>
                <button type="button" class="mnt-close-btn" (click)="dismissMaintenanceOverlay()"><span class="pi pi-check"></span> Entendido</button>
            </div>
        </div>
    </div>
    <!-- FOOTER -->
    <footer class="app-footer" aria-label="Pie de página plataforma">
        <div class="foot-inner">
            <span class="copy">© {{ currentYear }} OLDELVAL</span>
            <span class="sep" aria-hidden="true">·</span>
            <span class="made">Desarrollado por <span class="brand">Blister</span></span>
        </div>
    </footer>
</div>
